import { format } from "date-fns";
import httpErrorMessages from "./../constant/httpErrorMessages";
import asyncConfig from "./../asyncConfig.js";

/**
 * Required node environment variable
 * VUE_APP_CLIENT_ID : realm id
 * VUE_APP_USERNAME : username used to login
 * VUE_APP_PASSWORD : password used to login
 */
export default {
  install(Vue, options) {
    const axios = require("axios");

    // Parent route and vuex store
    const store = options.store;

    const includedMaintenanceUrl = [
      "/aceas/api/internet/feedback/v1/feedbacks/create",
      "/aceas/api/internet/feedback/v1/complaints/create",
      "/aceas/api/internet/feedback/v1/complaints/draft",
      "/aceas/api/internet/feedback/v1/complaints/UpdateDraft"
    ];

    axios.interceptors.request.use(async config => {
      const routePath = window.location.pathname;
      if (routePath.includes("/aceas/feedback-management")) {
        const isUrlIncluded = includedMaintenanceUrl
          .map(v => config.url.includes(v))
          .includes(true);

        if (isUrlIncluded) {
          const commonConfig = await asyncConfig.getCommonConfig();

          const isUnderMaintenance = commonConfig?.data?.maintenanceInfo
            .map(v => v.isUnderMaintenance)
            .includes(true);

          if (isUnderMaintenance) {
            window.Vue.prototype.$buefy.dialog.alert({
              message:
                "We apologize, but our systems are currently undergoing maintenance. You are unable to submit the form at this time. Please try again later. Do not refresh the page, as this may result in losing your form data.",
              type: "is-danger",
              hasIcon: true,
              icon: "exclamation-circle",
              iconPack: "fa",
              onConfirm: () => {
                // window.location.href = "/aceas/maintenance";
                return;
              }
            });
            return;
          }
        }
      }

      return config;
    });

    let tempToken;
    const redirectionStatusCondition = [401, 403, 404, 408];

    // Fetch access token for development environment only
    const fetchAccessToken = function(obj, type) {
      if (process.env.NODE_ENV === "development") {
        const qs = require("qs");
        const url_login =
          "http://xtr-sg-dev-aceas-int-ingress-alb-418156689.ap-southeast-1.elb.amazonaws.com/aceas/auth/realms/aceas-internet-dev/protocol/openid-connect/token";
        const body_login = {
          client_id: process.env.VUE_APP_CLIENT_ID,
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD,
          grant_type: "password"
        };
        return axios({
          method: "post",
          url: url_login,
          data: qs.stringify(body_login),
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=utf-8"
          }
        })
          .then(response => {
            store.commit("auth/setAccessToken", response.data.access_token);
            if (type == "post") {
              postRequest(
                obj.urlEndpoint,
                obj.body,
                obj.cbSuccess,
                obj.cbFail,
                obj.obj
              );
            } else {
              getRequest(obj.urlEndpoint, obj.cbSuccess, obj.cbFail, obj.obj);
            }
          })
          .catch(e => {
            return e;
          });
      }
    };

    const getError = (status, obj, nativeError) => {
      let message;
      const isNeedRedirection = obj;
      const hereHyperlinkURL =
        store.state.config.configurationData.environment === "prd"
          ? "https://www.cea.gov.sg/feedback"
          : "/aceas/feedback-management";

      const parseValidationError = data => {
        let result = "";
        for (const [key, value] of Object.entries(data).sort()) {
          result += key + " : ";
          result += Array.isArray(value) ? value.toString() : value;

          result += "<br /><br />";
        }

        return result;
      };

      const currentDate = format(new Date(), "dd/MM/yyy HH:mm:ss");
      switch (status) {
        case 400:
          // message = httpErrorMessages[400](currentDate);
          if (
            nativeError.response &&
            nativeError.response.data &&
            nativeError.response.data.data &&
            nativeError.response.data.data.message
          ) {
            const dateTimeText = `<p>Date and Time : ${currentDate}</p>`;

            message = Array.isArray(nativeError.response.data.data.message)
              ? nativeError.response.data.data.message.toString() +
                "<br /><br />" +
                dateTimeText
              : nativeError.response.data.data.message
              ? nativeError.response.data.data.message +
                "<br /><br />" +
                dateTimeText
              : typeof nativeError.response.data.data === "object"
              ? parseValidationError(nativeError.response.data.data) +
                dateTimeText
              : JSON.stringify(nativeError.response.data.data) +
                "<br /><br />" +
                dateTimeText;
          } else {
            if (
              nativeError.response &&
              nativeError.response.data &&
              nativeError.response.data.data
            ) {
              const dateTimeText = `<p>Date and Time : ${currentDate}</p>`;
              message =
                typeof nativeError.response.data.data === "object"
                  ? parseValidationError(nativeError.response.data.data) +
                    dateTimeText
                  : JSON.stringify(nativeError.response.data.data) +
                    "<br /><br />" +
                    dateTimeText;
            } else {
              message = httpErrorMessages[400](currentDate, hereHyperlinkURL);
            }
          }

          break;
        case 401:
          message = httpErrorMessages[401](currentDate, hereHyperlinkURL);
          store.commit("auth/setIsSessionActive", false);
          break;
        case 403:
          message = httpErrorMessages[403](currentDate, hereHyperlinkURL);
          if (isNeedRedirection) window.location.href = "/aceas/access-denied";
          break;
        case 404:
          message = httpErrorMessages[404](currentDate, hereHyperlinkURL);
          if (isNeedRedirection) window.location.href = "/aceas/not-found";
          break;
        case 408:
          message = httpErrorMessages[408](currentDate, hereHyperlinkURL);
          if (isNeedRedirection)
            window.location.href = "/aceas/request-timeout";
          break;
        case 500:
          if (
            nativeError.response &&
            nativeError.response.data &&
            nativeError.response.data.data &&
            nativeError.response.data.data.correlationId
          ) {
            const correlationId = nativeError.response.data.data.correlationId;
            message = httpErrorMessages[500](
              currentDate,
              correlationId,
              hereHyperlinkURL
            );
          } else {
            message = httpErrorMessages[500](
              currentDate,
              null,
              hereHyperlinkURL
            );
          }

          break;
        case 502:
          message = httpErrorMessages[502](currentDate, hereHyperlinkURL);
          break;
        case 503:
          message = httpErrorMessages[503](currentDate, hereHyperlinkURL);
          break;
        case 504:
          message = httpErrorMessages[504](currentDate, hereHyperlinkURL);
          break;
        default:
          message = `<p><strong>Unknown Error ${
            status ? `(${status})` : ""
          }</strong></p><div><p>The service is temporarily unable to process your request. Alternatively, you may try following: </p></div>
          <div>
              <ul class="xb-ul">
              <li>Ensure the URL entered is correct.</li>
              <li>Reload the web page.</li>
              <li>Clear your browser’s cache / cookies.</li>
              </ul>
              <br />
              <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
              <p>Date and Time : ${currentDate}</p>
          </div>`;
      }

      return { message };
    };

    const postRequest = async (
      urlEndpoint,
      body,
      cbSuccess,
      cbFail,
      obj = {}
    ) => {
      const token =
        process.env.NODE_ENV === "development"
          ? tempToken
            ? tempToken
            : store.state.auth.accessToken
          : store.state.auth.accessToken;

      let headers = {
        Authorization: `Bearer ${token}`
      };

      if (obj.captchaActionName) {
        const captchaToken = await window.Vue.prototype.$recaptcha.load(
          obj.captchaActionName
        );
        if (captchaToken) headers["X-Captcha-Token"] = captchaToken;
      }

      return axios
        .post(urlEndpoint, body, {
          headers
        })
        .then(response => {
          if (response.data.status < 400) {
            if (typeof obj !== "undefined") {
              cbSuccess(response, obj);
            } else {
              cbSuccess(response);
            }
          } else {
            if (
              response.data.status == 401 &&
              process.env.NODE_ENV === "development" &&
              !tempToken
            ) {
              fetchAccessToken(
                { urlEndpoint, body, cbSuccess, cbFail, obj },
                "post"
              );
            } else {
              const { message } = getError(
                response.data.status,
                obj && typeof obj.redirection === "boolean"
                  ? obj.redirection
                  : true,
                response
              );
              if (
                (obj &&
                  typeof obj.redirection === "boolean" &&
                  !obj.redirection) ||
                !redirectionStatusCondition.includes(response.data.status)
              )
                cbFail(message, response);
            }
          }
        })
        .catch(e => {
          if (
            process.env.NODE_ENV === "development" &&
            !tempToken &&
            e.response.status === 401
          ) {
            fetchAccessToken(
              { urlEndpoint, body, cbSuccess, cbFail, obj },
              "post"
            );
          } else {
            const isKnownError = e.response && e.response.status;
            const { message } = isKnownError // To prevent error from UI generate misleading error
              ? getError(
                  e.response.status,
                  obj && typeof obj.redirection === "boolean"
                    ? obj.redirection
                    : true,
                  e
                )
              : e;

            if (
              (obj &&
                typeof obj.redirection === "boolean" &&
                !obj.redirection) ||
              (e.response &&
                e.response.status &&
                !redirectionStatusCondition.includes(e.response.status)) ||
              !isKnownError
            )
              cbFail(message, e);
          }
        });
    };

    const getRequest = (urlEndpoint, cbSuccess, cbFail, obj = {}) => {
      const token =
        process.env.NODE_ENV === "development"
          ? tempToken
            ? tempToken
            : store.state.auth.accessToken
          : store.state.auth.accessToken;

      const body = obj.body || {};

      return axios
        .get(urlEndpoint, {
          ...body,
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          if (response.data.status < 400) {
            if (typeof obj !== "undefined") {
              cbSuccess(response, obj);
            } else {
              cbSuccess(response);
            }
          } else {
            if (
              response.data.status == 401 &&
              process.env.NODE_ENV === "development" &&
              !tempToken
            ) {
              fetchAccessToken({ urlEndpoint, cbSuccess, cbFail, obj }, "get");
            } else {
              const { message } = getError(
                response.data.status,
                obj && typeof obj.redirection === "boolean"
                  ? obj.redirection
                  : true,
                response
              );
              if (
                (obj &&
                  typeof obj.redirection === "boolean" &&
                  !obj.redirection) ||
                !redirectionStatusCondition.includes(response.data.status)
              )
                cbFail(message, response);
            }
          }
        })
        .catch(e => {
          if (
            process.env.NODE_ENV === "development" &&
            !tempToken &&
            e.response.status === 401
          ) {
            fetchAccessToken({ urlEndpoint, cbSuccess, cbFail, obj }, "get");
          } else {
            const isKnownError = e.response && e.response.status;
            const { message } = isKnownError // To prevent error from UI generate misleading error
              ? getError(
                  e.response.status,
                  obj && typeof obj.redirection === "boolean"
                    ? obj.redirection
                    : true,
                  e
                )
              : e;
            if (
              (obj &&
                typeof obj.redirection === "boolean" &&
                !obj.redirection) ||
              (e.response &&
                e.response.status &&
                !redirectionStatusCondition.includes(e.response.status)) ||
              !isKnownError
            )
              cbFail(message, e);
          }
        });
    };

    Vue.prototype.$api = {
      post: postRequest,
      get: getRequest
    };
  }
};
